import React from 'react';

const OrderUpdate = () => {
    return (
        <div>
            order update
        </div>
    );
};

export default OrderUpdate;